
import { IonPage, IonHeader, IonTitle, IonToolbar, IonButton, IonContent,IonNote, IonFooter } from "@ionic/vue";
import { chevronForward } from "ionicons/icons";
import { defineComponent } from "vue";
import useTranslate from "../components/ts/translateService";
import { reactive } from "vue";
export default defineComponent({
  name: "HomePage",
  components: { IonPage, IonHeader, IonTitle, IonToolbar, IonButton, IonContent, IonNote, IonFooter } ,
  setup() {
    const language = reactive({
        abbrev: "fr",
    });

    //localStorage.removeItem("lang") ;

    function setLang(target: string): void {
      localStorage.setItem("lang", target);
      language.abbrev = target;
    }
    const getLanguage = localStorage.getItem("lang");
    if (getLanguage) {
      language.abbrev = getLanguage;
    } else {
      localStorage.setItem("lang", "fr");
    }
    return { useTranslate, chevronForward, setLang, language };
  }
});
